import { observer } from "mobx-react";
import Card from "../../../../components/layouts/card/card";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import currentPortalStore from "../../../../stores/current-portal-store";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import "./returns-portal-preview-mode-card.scss";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardTranslationsStore from "../../../../dashboard-translation/stores/dashboard-translations-store";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { ButtonLink } from "../../../../components/inputs/button-link/button-link";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Tooltip } from "../../../../components/tooltip/tooltip";
import Icon from "../../../../components/icons/icon/icon";
import IconInfo from "../../../../components/icons/icon-info/icon-info";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { TOOLTIP_PLACEMENTS } from "../../../../components/tooltip/tooltip-box";
import { ClipboardCopyInput } from "../../../../components/inputs/clipboard-copy-input/clipboard-copy-input";
import rmsMixpanelStore from "../../../../stores/rms-mixpanel-store";
import {
    trackTranslationValidationOpened,
    TranslationEntryPoint,
    TranslationSurface,
} from "../../../../translation/metrics/translations-mixpanel";

const trackPortalPreviewOpened = () => trackTranslationValidationOpened({
    validation_type: "portal_preview",
    surface: TranslationSurface.PortalContent,
    scope: "assistant",
    entry_point: TranslationEntryPoint.ObjectPage,
});

const ReturnsPortalPreviewModeCard: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const isLoading = currentPortalStore.isLoading || dashboardTranslationsStore.isLoading;
    const isContentReady = !isLoading;
    const translationScope = 'dashboard-home';

    return (
        <Card
            isLoading={isLoading}
        >
            {isContentReady && (
                <>
                    <FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY3}>
                        {getTranslation('RETURNS_PORTAL', translationScope)}
                    </FontHeading2>
                    <div className="returns-portal-preview-mode-content" onClick={() => rmsMixpanelStore.trackEvent('d&_home_return_portal_area')}>
                        <FontBody1>
                            {getTranslation('PORTAL_URL_SHARE_DESCRIPTION', translationScope)}
                        </FontBody1>
                        <ClipboardCopyInput
                            value={currentPortalStore.setting?.returnsPortalLink ?? ''}
                        />
                        <div className="returns-portal-preview-mode-button-container">
                            <span onClick={trackPortalPreviewOpened}>
                                <ButtonLink
                                    href={currentPortalStore.setting?.returnsPortalPreviewLink}
                                    target="_blank"
                                    variant={BUTTON_VARIANTS.Primary}
                                    text={getTranslation('PREVIEW_MODE', translationScope)}
                                />
                            </span>
                            <Tooltip
                                placement={TOOLTIP_PLACEMENTS.LEFT}
                                content={<div className="returns-portal-preview-mode-tooltip">
                                <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                                    {getTranslation('PREVIEW_MODE_DESCRIPTION', translationScope)}
                                </FontBody2></div>}>
                                <Icon Component={IconInfo} />
                            </Tooltip>
                        </div>
                    </div>
                </>
            )}
        </Card>
    );
});

export default ReturnsPortalPreviewModeCard;
